import React from 'react';
import Heading from './components/Heading';
import Content from './components/Content';
import Footer from './components/Footer';

export default function App() {
  return (
    <div className="main-container">
      <Heading/>
      <Content/>
      <Footer/>
    </div>
  )
}
